/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { labelSelectors } from '../../../../../../../../app/resource/label/label.selectors';
import { taskSimpleSelectors } from '../../../../../../../../app/resource/task-simple/task-simple.selectors';
import { clearTaskModalStatuses } from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import useOutsideClick from '../../../../../../../../utils/click.utils';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { LabelForm } from '../../../../../forms/LabelForm';

import { Label } from './Label';
import { ILabelMenuProps } from './types';

export const LabelMenu: FunctionComponent<ILabelMenuProps> = ({ dropRight, closeMenu, taskId, triggerRef }) => {
  const [createForm, setCreateForm] = useState(false);
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '');

  const meetingId = task?.meetingIds?.[0] ?? '';
  const allMeetingLabels = useSelectWithParams(labelSelectors.selectLabelsByMeetingId, meetingId);

  const toggleCreate = () => {
    setCreateForm(!createForm);
  };
  const showLoader = false;
  const dispatch = useDispatch();

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskLabels');
  const open1 = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskLabels1');
  const popupRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = () => {
    if (open || open1) {
      dispatch(clearTaskModalStatuses());
    }
  };

  useOutsideClick({
    callback: handleClickOutside,
    refs: [popupRef, triggerRef],
    enabled: open || open1,
  });
  return (
    task && (
      <div
        className={dropRight ? 'dropdown-menu drop-right' : 'dropdown-menu'}
        style={showLoader ? { pointerEvents: 'none' } : {}}
      >
        <div className="mini-popup" ref={popupRef}>
          <div className="mini-popup-header">
            Labels
            <span className="close_mini_popup" onClick={closeMenu}>
              ×
            </span>
          </div>
          <div className="mini-popup-body">
            <div className="list-labels">
              {allMeetingLabels &&
                allMeetingLabels.map((label) => (
                  <Label labelId={label.id} key={`labelId-${label.id}`} taskId={taskId} />
                ))}
              <div className={createForm ? 'one-label edited' : 'one-label'}>
                <a className="badge gray-bg darkGray jcl edit-label w100 mx-0 mt-1" onClick={toggleCreate}>
                  Create a new label
                </a>
                {createForm && (
                  <div className="edit-label-container">
                    {task && <LabelForm onClick={toggleCreate} meetingId={meetingId} />}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
